<template>
  <div class="hvh-flex column space-between">
    <div>
      <h2 class="hvh-h5 mb-3">Gender Distribution</h2>
      <div class="legend-box hvh-flex align-center">
        <div class="legend-sqare male mr-1" />
        <span class="mr-1">Male</span>
        <div class="legend-sqare female ml-3 mr-1" />
        <span>Female</span>
      </div>
    </div>
    <HvhChart :visualization="donutChartData" :options="pieChartAgeOptions" height="300px" @item-clicked="emitValue" />
  </div>
</template>

<script>
import { customNumberFormat } from '../../../../libraries/common';
import HvhChart from '../../../charts/HvhChart.vue';
export default {
  components: { HvhChart },
  props: ['cohort', 'value'],
  data() {
    return {
      pieChartAgeOptions: {
        series: [
          {
            top: 30,
          }
        ]
      }
    };
  },
  computed: {
    donutChartData() {
      var { maleCount, femaleCount } = this.cohort.cohortStatistic;
      var isUncheckedColor = key => (this.value || []).any() && !(this.value || []).includes(key) && 'rgb(216,216,216)';
      return {
        visualization_type: 'donutchart',
        data: [
          {
            name: 'Male',
            value: maleCount,
            formattedValue: customNumberFormat(maleCount),
            color: isUncheckedColor('Male') || '#2F6B7E',
          },
          {
            name: 'Female',
            value: femaleCount,
            formattedValue: customNumberFormat(femaleCount),
            color: isUncheckedColor('Female') || '#23B47F',
          }
        ]
      };
    }
  },
  methods: {
    emitValue(event) {
      var value = (this.value?.length !== this.donutChartData.data.length && this.value) || [];
      var sortedValue = value
        .toggle(event.name)
        .sortBy(f => f);
      this.$emit('input', sortedValue);
    },
  },
}
</script>

<style lang="scss" scoped>
.legend-box {
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #8ccac8;
  background-color: #f5fbfb;
  padding: 10px;

  .legend-sqare {
    box-sizing: border-box;
    height: 12px;
    width: 12px;
    border: 0.25px solid #000000;

    &.male {
      background-color: #2f6b7e;
    }
    &.female {
      background-color: #23b47f;
    }
  }
}
</style>